module.exports = __webpack_public_path__ + "media/Resources/Ngo-0b59db6e.svg";